export default __webpack_public_path__ + "media/vendors/google_play_download-37118465.svg";